const SentryError = () => {
  const throwError = () => {
    throw new Error('Test Error');
  };

  return <button onClick={throwError}>Test Error</button>;
};

export default SentryError;
